/** The bell's "your report is ready" (item 63): one row per ready Insights
 *  report, which opens the report in Insights → Reports. It names the report
 *  and the days it covers - never its content. */
import { FileTextOutlined } from '@ant-design/icons';
import { useLanguage } from '@/hooks/useLanguage';
import { windowLabel } from '@modules/insights/components/reports/reportParts';
import type { ReportReadyNotification } from '../types';
import { relativeTime } from './InvitationCard';
import './InvitationCard.css';

interface Props {
  notification: ReportReadyNotification;
  onOpen: (reportId: string) => void;
}

export function ReportReadyCard({ notification, onOpen }: Props) {
  const { t } = useLanguage();
  const { title, period } = notification.payload;
  const days = period?.start && period?.end ? windowLabel({ start: period.start, end: period.end }, { year: false }) : '';
  return (
    <article className={`invite-card ${notification.read ? '' : 'is-unread'}`}>
      <button type="button" className="invite-card-top is-toggle report-card-top"
              onClick={() => onOpen(notification.subject_id)}>
        <span className="report-card-icon" aria-hidden="true"><FileTextOutlined /></span>
        <span className="invite-card-heading">
          <span className="invite-card-lede"><strong>{t('insights.reports.bell.ready')}</strong></span>
          {/* The line reads in the UI's direction; a title in another language
              keeps its own (dir=auto would turn the whole line round). */}
          <span className="invite-card-org">
            <bdi dir="auto">{title}</bdi>{days ? <> · <bdi>{days}</bdi></> : null}
          </span>
        </span>
        <time className="invite-card-time" dateTime={notification.created_at || undefined} dir="auto">
          {relativeTime(notification.created_at, t)}
        </time>
      </button>
    </article>
  );
}
